import './style.scss';
import { Slider } from '../../../js/components/Slider/Slider';
import { showPopup } from '../../../js/components/popups';

export default !function () {
  const block = document.querySelector('.soundcloud');

  if (!block) {
    return;
  }

  const averagePhone = window.matchMedia("(max-width: 375px)");
  const bigPhone = window.matchMedia("(max-width: 425px)");
  const tablet = window.matchMedia("(max-width: 767px)");
  const desktop = window.matchMedia("(max-width: 1279px)");

  // для тултипов
  const bigTablet = window.matchMedia("(max-width: 1023px)");

  // soundcloud
  const items = [...document.querySelectorAll('.soundcloud-item')];
  const players = {};
  let interval;

  const pushAnalyticPlayerClick = (item, items) => {
    const number = items.indexOf(item) + 1;

    window.$analytics && window.$analytics.push('soundcloud-item-click', {
      number
    });
  };

  const initSoundcloudBlock = () => {
    items.forEach((item) => {
      const trackId = item.dataset.track;

      if (trackId) {
        const player = {};

        player.widget = cratePlayer(item, trackId);
        player.trackId = trackId;
        player.domItem = item;
        player.playerState = 'pause';

        players[trackId] = player

        initPlayerEvents(player);
      }
    })
  }

  const initPlayerEvents = (player) => {
    // подписка на события саундклауд
    /* eslint-disable */
    player.widget.bind(SC.Widget.Events.PLAY, () => {
      player.playerState = SC.Widget.Events.PLAY;
      player.domItem.classList.add('soundcloud-item--show-time');
      player.domItem.classList.remove('soundcloud-item--pause');
      player.domItem.classList.add('soundcloud-item--playing');
      calcAndSetActiveWidgetTime(player);
    });

    player.widget.bind(SC.Widget.Events.PAUSE, () => {
      player.playerState = SC.Widget.Events.PAUSE;
      player.domItem.classList.add('soundcloud-item--pause');

      clearInterval(interval);
      interval = null;
    });

    player.widget.bind(SC.Widget.Events.FINISH, () => {
      setDuration(player);
      player.domItem.classList.remove('soundcloud-item--playing');
      player.domItem.classList.remove('soundcloud-item--pause');
    });

    player.widget.bind(SC.Widget.Events.READY, () => {
      if (player.widget !== 'error') {
        initButton(player);
        setDuration(player);
      }
    });

    player.widget.bind(SC.Widget.Events.ERROR, () => {
      player.widget = 'error';
      player.playerState = SC.Widget.Events.PAUSE;

      player.domItem.classList.add('soundcloud-item--error');
    });
    /* eslint-enable */
  }

  const cratePlayer = (item, trackId) => {
    const iframe = document.createElement('iframe');

    iframe.allow = 'autoplay';
    iframe.tabIndex = -1;
    iframe.id = `soundcloud-frame-${trackId}`;
    iframe.classList.add('soundcloud__iframe', 'sr-only');
    iframe.src = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${trackId}`;

    item.append(iframe);
    // eslint-disable-next-line
    return SC.Widget(document.querySelector(`#soundcloud-frame-${trackId}`));
  }

  const initButton = (player) => {
    const button = player.domItem.querySelector('.soundcloud-item__control');

    button.addEventListener('click', () => {
      button.blur(); // иначе с фокусом слайдер не листается

      if (player.widget !== 'error') {
        toggleState(player);
      }
    });
  }

  const toggleState = (activePlayer) => {
    /* eslint-disable */
    if (activePlayer.playerState === SC.Widget.Events.PLAY) {
      activePlayer.widget.pause();
    } else {
      for (let key in players) {
        if (activePlayer !== players[key]) {
          setPlayerToDefault(players[key]);
        }
      }

      activePlayer.widget.play();
    }
    /* eslint-enable */

    pushAnalyticPlayerClick(activePlayer.domItem, items);
  }

  const setPlayerToDefault = (player) => {
    if (player.widget !== 'error') {
      player.widget.pause();
      player.widget.seekTo(0);
      // eslint-disable-next-line
      player.playerState = SC.Widget.Events.PAUSE;

      const mediaWrapper = player.domItem.querySelector('.soundcloud__media');
      mediaWrapper.dataset.time = player.duration && player.duration.string;

      player.domItem.classList.remove('soundcloud-item--pause');
      player.domItem.classList.remove('soundcloud-item--playing');
    }
  }

  const calcAndSetActiveWidgetTime = (player) => {
    let position;

    // так работают геттеры у саундклауд, они оправдывают это асинхронность и общения через postMessage
    const getTrackPosition = (timestamp) => { position = timestamp / 1000 }

    const calcRemaining = () => {
      player.widget.getPosition(getTrackPosition);

      if (player.duration && position) {

        const mediaWrapper = player.domItem.querySelector('.soundcloud__media');

        const remainingTime = player.duration.seconds - position;
        mediaWrapper.dataset.time = buildTimeString(remainingTime).string;
      }
    }

    if (!interval) {
      interval = setInterval(calcRemaining, 1000);
    }
  }

  const setDuration = (player) => {
    const mediaWrapper = player.domItem.querySelector('.soundcloud__media');

    if (!player.duration) {
      player.widget.getDuration((timestamp) => {
        player.duration = buildTimeString(timestamp / 1000);
        mediaWrapper.dataset.time = player.duration.string;
        player.domItem.classList.add('soundcloud-item--initialized');
      });
    } else {
      mediaWrapper.dataset.time = player.duration.string;
    }
  }

  const buildTimeString = (timestamp) => {
    const reminder = timestamp % 60;
    const minutes = Math.floor(timestamp / 60);
    const seconds = reminder.toFixed(0).padStart(2, 0)

    return {
      seconds: timestamp,
      string: `${minutes}:${seconds}`
    }
  }

  let soundCloudInitInterval = setInterval(() => {
    // eslint-disable-next-line
    if (typeof SC !== 'undefined' && SC.Widget) {
      initSoundcloudBlock();
      clearInterval(soundCloudInitInterval);
      soundCloudInitInterval = null;
    }
  }, 100);

  setTimeout(() => {
    soundCloudInitInterval && clearInterval(soundCloudInitInterval);
  }, 30000);
  // end soundcloud

  // swiper
  const ROTATE_ANGLE = 60;
  const CONTAINER_PADDING = 20;

  const wrapper = document.querySelector('.soundcloud__wrapper');
  const slides = [...document.querySelectorAll('.soundcloud-item')];
  const pictures = slides.map(slide => slide.querySelector('.soundcloud__picture'));

  // расчет прокрутки под каждый слайд (лучше не вникать без необходимости)
  const setTranslate = (_swiper, translate) => {
    if (!bigPhone.matches) {
      return;
    }

    const margin = Number(slides[0].style.marginRight.replace('px', ''));
    const containerWidth = document.querySelector('.ui-container').getBoundingClientRect().width - CONTAINER_PADDING * 2;
    const slideWidth = slides[0].getBoundingClientRect().width;
    const maxTranslate = (slideWidth * pictures.length) + (margin * (pictures.length - 1)) - containerWidth;
    const stepTranslate =  slideWidth + margin;

    // -2 это не магия, а константа, кроме первого и последнего слайдов
    const lastSlideTranslate = maxTranslate - (stepTranslate * (pictures.length - 2));
    const lastStepTranslateShift = stepTranslate - lastSlideTranslate;

    pictures.forEach((picture, index) => {
      const additionRotate = index * ROTATE_ANGLE;
      const angleForPixel = ROTATE_ANGLE / stepTranslate;

      let angle = translate * angleForPixel + additionRotate;

      if (index === (pictures.length - 1)) {
        angle = angle - angleForPixel * lastStepTranslateShift;
      }

      picture.style.transform = `rotate(${angle.toFixed(3)}deg)`;
    });
  }

  const initSwiper = () => {
    const list = document.querySelector('.soundcloud__list');
    let controls = document.querySelector('.soundcloud__pagination');

    if (!controls) {
      controls = document.createElement('div');
      controls.setAttribute('class', 'soundcloud__pagination');

      block.append(controls);
    }

    const options = {
      wrapper,
      settings: {
        spaceBetween: 12,
        loop: false,
        effect: 'slide',

        slideClass: 'soundcloud-item',
        slideActiveClass: 'soundcloud-item--active',
        wrapperClass: 'soundcloud__list',

        pagination: {
          el: '.soundcloud__pagination',
          clickable: true,
          bulletElement: 'button',
          bulletClass: 'soundcloud__pagination-item',
          bulletActiveClass: 'soundcloud__pagination-item--active'
        },

        navigation: false,

        on: {
          // тут все для анимации
          setTranslate,
          touchEnd: () => {
            bigPhone.matches && pictures.forEach((picture) => {
              picture.style.transition = `transform 300ms`;
            });
          },
          touchStart: () => {
            bigPhone.matches && pictures.forEach((picture) => {
              picture.style.transition = `transform 0ms`;
            });
          }
        },

        breakpoints: {
          375: {
            spaceBetween: 16
          },
          765: {
            spaceBetween: 32
          },
          1024: {
            spaceBetween: 36
          }
        },
      },
      modules: ['pagination', 'a11y'],
      initCondition: {
        sm: slides.length > 1,
        md: slides.length > 2,
        lg: slides.length > 2,
        xl: slides.length > 3
      },
      controls,
      createCallback: () => {
        list.classList.remove('soundcloud__list--not-slider');
      },
      destroyCallback: () => {
        list.classList.add('soundcloud__list--not-slider');
      }
    };

    new Slider(options).init();
  }

  initSwiper();

  const changeListener = () => {
    pictures.forEach((picture) => {
      picture.removeAttribute('style');
    });
  }

  changeListener();

  averagePhone.addEventListener('change', changeListener);
  bigPhone.addEventListener('change', changeListener);
  tablet.addEventListener('change', changeListener);
  desktop.addEventListener('change', changeListener);
  // end swiper


  // tooltips (потом уедет отсюда)
  const getTooltipTemplate = (values) => {
    return (`
      <strong class="info-tooltip__title f f--14 f--m">
        ${values.title}
      </strong>

      <p class="info-tooltip__subtitle f f--14">
        ${values.subtitle}
      </p>

      <p class="info-tooltip__desc f f--14">
        ${values.desc}
      </p>
    `);
  }

  const getPopupTemplate = (values) => {
    // иконка не будет отображаться на деве из-за неправильного пути, он продовский
    return (`
        <div class="popup__wrapper">
          <button
            class="popup__close popup-close js-popup__close"
            type="button"
            aria-label="Закрыть модальное окно"
            data-gtm="close"
          >
            <svg
              width="20"
              height="20"
              aria-hidden="true"
            >
              <use href="#ui-close" />
            </svg>
          </button>

          <div class="info-tooltip info-tooltip--popup">
            ${getTooltipTemplate(values)}
          </div>
        </div>
    `);
  }

  const renderTooltip = (evt, values) => {
    const TOOLTIP_OFFSET = 2;
    const el = evt.target.closest('.soundcloud-item__text--btn');
    const position = el.getBoundingClientRect();
    const body = document.querySelector('body');
    const tooltip = document.createElement('div');

    tooltip.classList.add('info-tooltip', 'info-tooltip--tooltip', 'info-tooltip--hidden');
    tooltip.innerHTML = getTooltipTemplate(values);

    body.append(tooltip);

    const elHeight = tooltip.getBoundingClientRect().height;
    const elWidth = tooltip.getBoundingClientRect().width;

    tooltip.style.left = elWidth + position.left < window.innerWidth
      ? `${position.left}px`
      : `${position.right - elWidth}px`;

    tooltip.style.top = `${position.top - elHeight - TOOLTIP_OFFSET}px`;

    tooltip.classList.remove('info-tooltip--hidden');
  }

  const renderPopup = (values) => {
    const body = document.querySelector('body');
    const tooltip = document.createElement('div');
    tooltip.classList.add('popup', 'js-popup', 'js-tooltip-popup');

    tooltip.innerHTML = getPopupTemplate(values);

    body.append(tooltip);

    showPopup(tooltip);

    const tooltipCloseBtn = document.querySelector('.js-tooltip-popup');

    tooltipCloseBtn.addEventListener('click', () => {
      tooltip.remove();
    });
  }

  const infoTooltips = document.querySelectorAll('.soundcloud-item__text--btn');

  infoTooltips.forEach(tooltip => {
    if (bigTablet.matches) {
      const el = tooltip.closest('.soundcloud-item');
      const values = { title: el.dataset.title, subtitle: el.dataset.subtitle, desc: el.dataset.desc };

      tooltip.addEventListener('click', () => {
        renderPopup(values);
      });
    } else {
      const el = tooltip.closest('.soundcloud-item');
      const values = { title: el.dataset.title, subtitle: el.dataset.subtitle, desc: el.dataset.desc };

      tooltip.addEventListener('mouseenter', (evt) => {
        renderTooltip(evt, values);
      });


      tooltip.addEventListener('mouseleave', () => {
        const tooltip = document.querySelector('.info-tooltip')
        tooltip && tooltip.remove();
      });

      tooltip.addEventListener('click', (evt) => {
        const tooltip = document.querySelector('.info-tooltip')

        tooltip
          ? tooltip.remove()
          : renderTooltip(evt, values);
      });
    }
  });
  // end tooltips
}();
